import { ProductType } from 'constants/product'

/**
 * The backend-computed classification-flag subset needed to derive the legacy type bucket.
 * Deliberately required (not optional) so a flag-less DTO (e.g. a price-line shape) cannot be
 * passed by accident and silently derive the permissive PHOTO bucket.
 */
export interface ProductTypeBucketFlags {
  isAiPhotoEditing: boolean
  isVideo: boolean
  isVirtualVisit: boolean
  isFloorPlan: boolean
}

/**
 * Derives the legacy ProductType *bucket* from the backend-computed classification flags
 * (ISSUE-2539), replacing reads of the deprecated wire `type` field ahead of its removal
 * (ISSUE-2745 / ISSUE-2215).
 *
 * While the backend's legacy type column exists, the flags carry a legacy-type shim, so this
 * derivation matches the wire `type` — including the two kinds that live under two types
 * (SD photo vs SD virtual visit; Matterport-with-visit resolves virtual-visit before floor-plan,
 * matching the legacy type those products carry).
 *
 * PHOTO is the fallback bucket — callers must not treat it as "definitely a photo product";
 * combine with the other flags (isStaging, documentSubtype, ...) where that distinction matters.
 */
export const deriveProductTypeBucket = (flags: ProductTypeBucketFlags): ProductType => {
  if (flags.isAiPhotoEditing) return ProductType.AI_PHOTO_EDITING
  if (flags.isVideo) return ProductType.VIDEO
  if (flags.isVirtualVisit) return ProductType.VIRTUAL_VISIT
  if (flags.isFloorPlan) return ProductType.FLOOR_PLAN
  return ProductType.PHOTO
}
